module.exports = __webpack_public_path__ + "img/FI.621ca26b.svg";